import Carousel from "react-multi-carousel";
import React, { useState, useEffect } from "react";
import 'react-multi-carousel/lib/styles.css';
import { useTranslation, Trans } from "next-i18next";

type Props = {
    className?: string,
};

const ClientTestimonials: React.FC<Props> = ({ className }) => {
    const { t } = useTranslation("home");
    const [isClient, setIsClient] = useState(false);
    
    useEffect(() => {
        setIsClient(true);
    }, []);

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    const testimonials = [
        {
            thought: t('testimonials.clients.client1.thought'),
            name: t('testimonials.clients.client1.name'),
            company: t('testimonials.clients.client1.company'),
            logo: "/images/mw-dardeen.svg",
            alt: "Bardeen"
        },
        {
            thought: t('testimonials.clients.client2.thought'),
            name: t('testimonials.clients.client2.name'),
            company: t('testimonials.clients.client2.company'),
            logo: "/images/trusted-company/mindorigin.svg",
            alt: "Mindorigin"
        },
        {
            thought: t('testimonials.clients.client3.thought'),
            name: t('testimonials.clients.client3.name'),
            company: t('testimonials.clients.client3.company'),
            logo: "/images/mw-cloudchip.svg",
            alt: "Cloudchipr"
        },
        {
            thought: t('testimonials.clients.client4.thought'),
            name: t('testimonials.clients.client4.name'),
            company: t('testimonials.clients.client4.company'),
            logo: "/images/mw-activeloop.svg",
            alt: "Activeloop"
        },
        {
            thought: t('testimonials.clients.client5.thought'),
            name: t('testimonials.clients.client5.name'),
            company: t('testimonials.clients.client5.company'),
            logo: "/images/client-logo/trademarkia.svg",
            alt: "Trademarkia"
        },
        {
            thought: t('testimonials.clients.client6.thought'),
            name: t('testimonials.clients.client6.name'),
            company: t('testimonials.clients.client6.company'),
            logo: "/images/trusted-company/aceturtle.svg",
            alt: "Ace Turtle"
        }
    ];

    return <>
        <div className={`mw-carousel ${className ? className : ''}`}>
            <div className={'container'}>
                <div className={'section-tag testimonial'}>{t('testimonials.tag')} 👤</div>
                <h2>
                  <Trans
                    ns="home"
                    i18nKey="testimonials.title"
                    components={{
                      highlight: <span className="text-gradient" />,
                    }}
                  />
                </h2>
                {isClient ? (
                    <Carousel responsive={responsive} infinite={true}>
                        {testimonials.map((testimonial, index) => (
                            <div key={index}>
                                <div className={'mw-testimonial'}>
                                    <div className={'d-flex'}>
                                        <div className={'content'}>
                                            <p>{testimonial.thought}</p>
                                        </div>
                                        <div className={'author-details'}>
                                            <p className={'author-name'}>{testimonial.name}</p>
                                            <p className={'client-name'}>{testimonial.company}</p>
                                            <div className={'client-logo'}>
                                                <img src={testimonial.logo}
                                                       alt={testimonial.alt} width={160} height={160} className={"black-white"}
                                                       loading="lazy" decoding="async"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Carousel>
                ) : (
                    // SSR fallback - render first testimonial statically
                    <div className={'mw-testimonial'}>
                        <div className={'d-flex'}>
                            <div className={'content'}>
                                <p>{testimonials[0].thought}</p>
                            </div>
                            <div className={'author-details'}>
                                <p className={'author-name'}>{testimonials[0].name}</p>
                                <p className={'client-name'}>{testimonials[0].company}</p>
                                <div className={'client-logo'}>
                                    <img src={testimonials[0].logo}
                                           alt={testimonials[0].alt} width={160} height={160} className={"black-white"}
                                           loading="lazy" decoding="async"/>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    </>
}
export default ClientTestimonials;
